import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { ExternalIntegrationEnum, TikTokIntegration } from 'api/clients/ExternalIntegrationsClient'
import { TikTok } from 'almanac-ui/icons'
import { CardButtons } from './CardButtons'
import { useInitiateOauth } from 'hooks/useInitiateOauth'

export const TikTokCard = ({
  integrations = [],
  isDisconnected = false,
}: {
  integrations?: TikTokIntegration[]
  isDisconnected?: boolean
}) => {
  const { initiateOauth } = useInitiateOauth()

  const handleInitiateTikTokOauth = () => {
    initiateOauth(ExternalIntegrationEnum.TikTok)
  }

  const scopeIsOutdated = integrations.some((integration) => !integration.scopes?.includes('video.list'))

  return (
    <ExternalIntegrationCard
      title="TikTok"
      description={'Post directly to your TikTok account'}
      integrations={integrations}
      icon={<TikTok size={20} />}
      isDisconnected={isDisconnected}
      buttons={
        <CardButtons
          onConnect={handleInitiateTikTokOauth}
          provider={ExternalIntegrationEnum.TikTok}
          isConnected={integrations.length > 0}
          integration={integrations[0]}
          isDisconnected={isDisconnected}
          isOutdated={scopeIsOutdated}
        />
      }
    />
  )
}
